import { useCallback, type ReactNode } from 'react';
import { useQueryClient } from '@tanstack/react-query';
import { AnalyticsProvider } from 'shared/src/context';
import type { ILogging } from 'shared/src/api/types/ILogging';
import { useInstanceId } from 'shared/src/hooks';
import { useGetCommonParams } from '../hooks';
import { getScreensInfiniteQueryData } from './hooks/useGetScreensInfiniteQuery';

type Props = {
  children: ReactNode;
};

export const ScreensAnalyticsProvider = ({ children }: Props) => {
  const queryClient = useQueryClient();
  const { nextToken, screenName } = useGetCommonParams();
  const instanceId = useInstanceId();

  const getDefaults = useCallback((): ILogging | undefined => {
    if (!screenName) return undefined;
    const data = getScreensInfiniteQueryData(queryClient, {
      screenName,
      nextToken,
      instanceId,
    });
    return data?.pages[data.pages.length - 1]?.logging;
  }, [queryClient, screenName, nextToken, instanceId]);

  return (
    <AnalyticsProvider screen={screenName ?? ''} getDefaults={getDefaults}>
      {children}
    </AnalyticsProvider>
  );
};
